export const environment = {
  production: true,
  APIURL : 'https://sdigilocally.deloitte.co.il/webapi/api/',
  ImageURL :'https://sdigilocally.deloitte.co.il/assets/images/',
  Mobile:'https://sm.digilocally.deloitte.co.il'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts